import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { SERVICE_STATUS_TYPE } from '../../../../util/constant';
import { loggedInUser, factoryId } from '../../../../store/reducers/account_reducer';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from '../../../../util/helper';
import { Link } from 'react-router-dom';
import { setBreadCrumb } from '../../../../store/reducers/menu_reducer';
import { getOverdueServices } from '../../../../services/mm/apiController';

const ServiceOverdue = () => {
  const [list, setList] = useState(null);
  let user = useSelector(loggedInUser);
  const dispatch = useDispatch();
  const factoryId_ = useSelector(factoryId);

  useEffect(() => {
    getAOverdueService();
  }, [factoryId_]);

  const getAOverdueService = async () => {
    const overdueService = await getOverdueServices(factoryId_,"OVERDUE",1);
    setList(overdueService.data);
  };

  // useEffect(() => {
  //   if (factoryId_) {
  //     axios
  //       .get(`/mm/installation/getDues`, {
  //         params: {
  //           status: SERVICE_STATUS_TYPE.OVERDUE,
  //           days: 1,
  //           factoryId: (factoryId_) || null,
  //         },
  //       })
  //       .then((resp) => {
  //         setList(resp && resp.data && resp.data.data);
  //       })
  //       .catch((error) => {
  //         setList(null);
  //       });
  //   }
  // }, [factoryId_]);

  const breadCrumbChanges = (id) => {
    dispatch(
      setBreadCrumb({
        label: 'Installation Detail',
        value: `/installations/${id}`,
      })
    );
  };

  return (
    <React.Fragment>
      <div className="header-title">Overdue Services</div>
      <div className="card">
        <div className="card-body p-0">
          {(!list || list.length === 0) && (
            <div className="alert alert-warning mb-0" role="alert">
              <strong>No data available</strong>
            </div>
          )}
          {list && list.length > 0 && (
            <div className="table-responsive">
              <table className="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th>Machine</th>
                    <th>Asset #</th>
                    <th>Section</th>
                    <th>Service Info</th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.item}</td>
                        <td>
                          <Link to={`/mm/installation/${item?.id}/?activeTab=service-remainder`}>
                            <span onClick={() => breadCrumbChanges(item.id)}>{item?.itemNumber}</span>
                          </Link>
                        </td>
                        <td>{item.section}</td>
                        <td>
                          <ul className="list-group list-group-flush">
                          {item.service_remainders.map((item)=> {
                          return (
                            <li className="list-group-item p-0">
                              <p className="mb-0">{item?.name}</p>
                              <p className="mb-0">{item.description}</p>
                              <p className="mb-0 text-danger">{formatDate(item.dueDate)}</p>
                            </li>
                            );
                          })}
                          </ul> 
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      {/* <pre>{JSON.stringify(list, null, 4)}</pre> */}
    </React.Fragment>
  );
};

export default ServiceOverdue;
